export default __webpack_public_path__ + "static/illustration-25408c11db570b036e5d14b1657fd9f9.svg";